import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Constants } from '../Constants';
import { SharedService } from '../services/shared.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent  {

  resetPasswordForm: FormGroup
  constructor(
    private _loginService: LoginService,
    private _sharedService: SharedService,
    public dialogRef: MatDialogRef<ResetPasswordComponent>,
    private _fb: FormBuilder
  ) { 
    this.resetPasswordForm = this._fb.group({
      email: new FormControl('', [Validators.required, Validators.email, Validators.pattern(Constants.emailPattern)])
    })
  }

  onClose() {
    this.dialogRef.close();
  }

  onResetPassword() {
    if(this.resetPasswordForm?.valid) {
      const { email } = this.resetPasswordForm.value;
      this._loginService.resetpassword(email).subscribe((response: any) => {
        if(response['success']) {
          this._sharedService.openSnackBar(response['message']);
          this.onClose();
        }
      })
    } else {
      this.resetPasswordForm.controls['email'].markAsTouched();
      this.resetPasswordForm.controls['email'].updateValueAndValidity();
    }
  }

}
